export default {
  'clocks': [
    'clock0830_1200',
    'clock1200_1700'
  ],
  'permanentRequiredFields': [
    'Salutation',
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ]
}
